module.exports = __webpack_public_path__ + "img/color_azul.d1aa274a.svg";